require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-execute-brain.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-execute-brain");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-execute-brain!./.cache/json/coding-interview-prep-rosetta-code-execute-brain.json
// module id = 1877
// module chunks = 231608221292675